<template>
    <div v-if="isOpen">
        <div class="overlay" @click="closeModal"></div>
        <div class="modal-container">
            <div class="modal-body">Escolha os dias da semana</div>

            <div class="multi-select-list">
                <label
                    v-for="(option, key) in options"
                    :key="key"
                    class="option-label"
                >
                    <input
                        type="checkbox"
                        :value="option.value"
                        v-model="selectedOptions"
                    />
                    {{ option.label }}
                </label>
            </div>

            <div class="modal-footer">
                <button @click="closeModal">Confirmar</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'WeekDaysModal',
    data () {
        return {
            selectedOptions: [],
            options: [
                { value: 'Domingo', label: 'Domingo' },
                { value: 'Segunda-feira', label: 'Segunda-feira' },
                { value: 'Terça-feira', label: 'Terça-feira' },
                { value: 'Quarta-feira', label: 'Quarta-feira' },
                { value: 'Quinta-feira', label: 'Quinta-feira' },
                { value: 'Sexta-feira', label: 'Sexta-feira' },
                { value: 'Sábado', label: 'Sábado' }
            ]
        }
    },
    props: ['label', 'initialDays', 'isOpen'],
    emits: ['closeModal'],
    computed: {
    },
    methods: {
        toggleList () {
        },
        closeModal () {
            const selectedDays = this.options.filter(option => this.selectedOptions.includes(option.value))
            const selectedDayNames = selectedDays.map(option => option.value)
            this.$emit('closeModal', selectedDayNames)
        },
        ...mapActions(['changeWeekDaysModalVisibility'])
    },
    watch: {
        initialDays (val) {
            this.selectedOptions = val
        }
    }
}
</script>

<style lang="less" scoped>
  .modal-container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto auto;
    border-radius: 10px;
    z-index: 3;
    box-shadow: 2px 2px 4px var(--cardBorder);
    background-color: var(--backgroundColor);
    height: max-content;
    width: max-content;
    .modal-body {
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        margin-top: 20px;
        margin-bottom: 10px;
        padding: 0 10px;
    }

    .multi-select-list {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        justify-content: center;
        margin-bottom: 15px;
        padding-left: 20px;
    }
    .option-label {
        display: block; /* Cada opção em uma linha */
        margin: 5px 0; /* Espaçamento entre as opções */

        input {
          accent-color: var(--buttonBackground);
        }
    }

    .modal-footer {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        margin-bottom: 10px;
        margin-top: 20px;
        button {
            color: var(--buttonText);
            background: var(--buttonBackground);
            padding: 5px 10px;
            border: none;
            border-radius: 5px;
            font-size: 1rem;
            min-width: 90px;
        }
    }
}
.overlay {
        position: fixed;
        top: 0; left: 0;
        height: 100vh;
        width: 100vw;
        overflow: hidden;
        background: var(--backgroundColorOverlay);
        z-index: 2;
    }
</style>
